import { UserActionTypes, UserActions } from './types';
import { User } from '../../models/user';

const initialState: User = {
  userId: '',
  email: '',
  error: undefined,
};

const userReducers = (state = initialState, action: UserActions) => {
  switch (action.type) {
    case UserActionTypes.ACTION_USER_CREATE:
      return {
        ...state,
        userId: action.payload.userId,
        email: action.payload.email,
      };
  }
  return state;
};

export default userReducers;